<template>
    <academic>
        <div
            class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg"
        >
            <breeze-table
                :fields="fields"
                :items="durationSemesters"
                :canView="
                    this.$page.props.auth.user.role.permissions.find(
                        (permission) =>
                            permission.name === 'View Duration Semester'
                    )
                "
            >
                <template #duration_id="data">
                    {{ data.item.duration?.start_month }} -
                    {{ data.item.duration?.end_month }}
                </template>
                <template #semester_id="data">
                    {{ data.item.semester?.title }}
                </template>
                <template #status="data">
                    {{ data.item.status ? "Active" : "Inactive" }}
                </template>
                <template #action="data">
                    <button-link
                        v-if="
                            this.$page.props.auth.user.role.permissions.find(
                                (permission) =>
                                    permission.name === 'Edit Duration Semester'
                            )
                        "
                        :href="
                            route(
                                'academic.durationSemester.edit',
                                data.item.id
                            )
                        "
                    >
                        Edit
                    </button-link>
                </template>
            </breeze-table>
        </div>
    </academic>
</template>

<script>
import Academic from "@/Pages/Academic/Academic";
import BreezeTable from "@/Components/Table";
import ButtonLink from "@/Components/ButtonLink";

export default {
    components: {
        Academic,
        BreezeTable,
        ButtonLink,
    },
    props: ["durationSemesters"],
    data() {
        return {
            fields: [
                { key: "duration_id", label: "Duration" },
                { key: "semester_id", label: "Semester" },
                { key: "start_month", label: "Start Month" },
                { key: "end_month", label: "End Month" },
                { key: "status", label: "Status" },
                { key: "action", label: "Action" },
            ],
        };
    },
};
</script>
